import { render } from "./MeshBackdrop.vue?vue&type=template&id=fe5d5ccc&scoped=true&ts=true"
import script from "./MeshBackdrop.vue?vue&type=script&lang=ts"
export * from "./MeshBackdrop.vue?vue&type=script&lang=ts"

import "./MeshBackdrop.vue?vue&type=style&index=0&id=fe5d5ccc&lang=scss&scoped=true"
import "./MeshBackdrop.vue?vue&type=style&index=1&id=fe5d5ccc&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.1.6__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5d5ccc"]])

export default __exports__